import { render, staticRenderFns } from "./InboundModalAlert.template.vue?vue&type=template&id=15a1ba0c&scoped=true&"
var script = {}
import style0 from "./InboundModalAlert.template.vue?vue&type=style&index=0&id=15a1ba0c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a1ba0c",
  null
  
)

export default component.exports